import React from 'react';
import { Carousel } from '../../Common/Lib/react-responsive-carousel/lib/es';
import ProjectDetails from '../ProjectDetailsCarousel/index'
import "../../Common/Lib/react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { PortfolioDetails} from '../../data';
import { useParams } from 'react-router-dom';

function RCarousel (){   
    let { projectid } = useParams();
 
        return (
            <Carousel interval={2000} selectedItem={projectid-1} transitionTime={500} autoPlay={false} infiniteLoop={true} showArrows={true} showStatus={false} showThumbs={false} showIndicators={false} animationHandler="fade" swipeable={false}
            // renderArrowPrev={this.renderArrowPrev} renderArrowNext={this.renderArrowNext}
            >
                { PortfolioDetails.map(item => 
                    <>
                        <ProjectDetails {...item}/>
                    </>
                )}
            </Carousel>
        );
    }

export default RCarousel;